import script from "./AppNav.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppNav.vue?vue&type=script&setup=true&lang=ts"

import "./AppNav.vue?vue&type=style&index=0&id=4084a576&lang=less"

const __exports__ = script;

export default __exports__